export default __webpack_public_path__ + "static/media/xclaim_bulk_energy.ff5b2650.png";